import '_tradeholding/scss/form/form.scss';
import 'ldbutton/dist/ldbtn.css';
import '@loadingio/loading.css/dist/loading.css';

import jQuery from 'jquery';
import config from '_config'

import Validator from '_loaders/Validator';
import BsButton from '_loaders/BsButton';
import Ajax from '_loaders/AjaxCalls';
import PluginBase from '_loaders/PluginBase';

class TH_Form extends PluginBase {
    constructor(formDOM) {
        super(formDOM);
        
        this.elems = {};
        this.__buildElems();

        this.dom.main.data('js-form', this);

        console.log(this.options);
        console.log(this.events);
    }

    /** Build a list with options that should be tried to be converted to a function from a JS Function
     * 
     */
    __buildFunctionOptions() {
        this.functionOptions = jQuery.merge(['send', 'beforeSubmit', 'afterSubmit', 'afterResponse'], this.functionOptions);
        super.__buildFunctionOptions();
    }

     /** Build the default dom structure of this plugin - if you want to specify default or additional dom elements, override this function in your extended class
     *
     */
    __buildDom() {
        this.dom = jQuery.extend(true, {
            submitButton: new BsButton(this.dom.main.find('.form-submit-button'))
        }, this.dom);

        return super.__buildDom();
    }

    /** Build the default options of this plugin - if you want to specify default events, override this function in your extended class
     * 
     */
    __buildDefaultOptions() {
        this.options = jQuery.extend(true, {
            send: this.defaultSendMethod,
            validate: true
        }, this.options);

        super.__buildDefaultOptions();
    }

    /** Build the default events of this plugin - if you want to specify default events, override this function in your extended class
     * 
     */
    __buildDefaultEvents() {
        this.events = jQuery.extend(true, {
            'submit': this.defaultSubmitMethod,
            'formJS.formResponse': this.defaultFormResponse,
            'formJS.successResponse': this.defaultSuccessResponse,
            'formJS.errorResponse': this.defaultErrorResponse
        }, this.events);

        super.__buildDefaultEvents();
    }

    /** Default event to run when a javascript form is submitted
     * 
     * 
     */
    defaultSubmitMethod(event) {
        let iterator;
        
        event.preventDefault();
        if (typeof this.instance.options.beforeSubmit == 'function') {
            if (!this.instance.options.beforeSubmit.apply(this.original, [event])) return false;
        }
        
        if (this.instance.options.validate && !this.instance.validateForm()) return false;
        if (this.instance.options.disableOnSubmit) this.instance._temporaryDisableFormFields();
        this.instance.dom.submitButton.startLoading();

        this.instance.options.send.apply(this, [event]);

        if (typeof this.instance.options.afterSubmit == 'function') {
            this.instance.options.afterSubmit.apply(this.original, [event]);
        }

        return false;
    }


    /** Temporary disable all the form fields
     * 
     */
    _temporaryDisableFormFields() {
        this.dom.main.find('input, textarea, select, button').each(function() {
            jQuery(this).data('form-temp-disable', jQuery(this).prop('disabled'));
            jQuery(this).prop('disabled', true);
        });

        this.dom.main.addClass('th-form-disabled');
    }

    /** Re enable all the form fields
     * 
     */
   _reEnableFormFields() {
        this.dom.main.find('input, textarea, select, button').each(function() {
            var originalStatus;

            if (typeof jQuery(this).data('form-temp-disable') != 'undefined') originalStatus = jQuery(this).data('form-temp-disable');
            else originalStatus = false;

            jQuery(this).prop('disabled', originalStatus)
        });

        this.dom.main.removeClass('th-form-disabled');
    }

    /** Send the form data to the specific javascript API
     * 
     * @param function responseFunction (the response function to call on the api response)
     * 
     */
    async defaultSendMethod() {
        let result;

        result = await Ajax.ajaxPost(config.apiUrl + this.instance.options.api + "/", {formData: this.instance.collectFormData()}, false);
        this.instance.dom.main.trigger('formJS.formResponse', [result]);
    }

    /** Default form success response function
     * 
     * @param object data 		(the response data received)
     * 
     */
    defaultSuccessResponse(event, data) {
        let message;

        if (typeof data.message != 'undefined') message = data.message;
        else message = "No message received";

        console.log("Form[SUCCESS]: ", data);
        alert("Form[SUCCESS]: " + message);
    
        return true;
    }

    /** Default form error response function
     * 
     * @param object data 		(the response data received)
     * 
     */
    defaultErrorResponse(event, data) {
        let mainError,
            selfRef = this.instance;

        if (typeof data.errors != 'undefined') {
            if (typeof data.errors['plain_message'] != 'undefined') mainError = data.errors['plain_message'];
            else mainError = 'No main error message!';

            jQuery.each(data.errors, function(k, v) {
                Validator.activate_error(selfRef.dom.main.find('#'+k), {error: v});
            });
        }

        console.log("Form[ERROR] data: ", data);
        alert("Form[ERROR]: " + mainError);

        return false;
    }

    
    /** Set the general form response function
     * 
     * @param str data 		(the response data received)
     * 
     */
    defaultFormResponse(event, data) {
        let iterator;

        if (typeof this.instance.options.afterResponse == 'function') {
            this.instance.options.afterResponse.apply(this.original, [event, data]);
        }
 
        if (data.result == false) this.instance.dom.main.trigger('formJS.errorResponse', [data]);
        else this.instance.dom.main.trigger('formJS.successResponse', [data]);

        if (this.instance.options.disableOnSubmit) this._reEnableFormFields();
        this.instance.dom.submitButton.stopLoading();
    }

    /** Build the input elements that belong to this form
     * 
     */
    __buildElems() {
        var selfRef = this;
    
        this.elems = {
            inputs: [],
            selects: [],
            textareas: [],
            quillEditors: [],
            inputsHidden: [],
            algoliaPlaces: []
        }
    
        this.dom.main.find('.form-line').each(function() {
            jQuery(this).find('input:not(.places-js)').each(function() {
                selfRef.elems.inputs.push(jQuery(this));
            });
    
            jQuery(this).find('select').each(function() {
                selfRef.elems.selects.push(jQuery(this));
            });
    
            jQuery(this).find('textarea').each(function() {
                selfRef.elems.textareas.push(jQuery(this));
            });
    
            jQuery(this).find('.quill-container .quill').each(function() {
                selfRef.elems.quills.push(jQuery(this));
            });

            jQuery(this).find('input.places-js').each(function() {
                selfRef.elems.algoliaPlaces.push(jQuery(this));
            });
        })
    
        this.dom.main.find('input:hidden').each(function() {
            selfRef.elems.inputsHidden.push(jQuery(this));
        });
    }

    /** Collect every data from the form
     * 
     * @param bool specialId (match the elems to the _id attribute instead of the normal id attribute, defaults to false)
     * 
     * @returns object (returns an object containing all the inputed data in the form)
     */
    collectFormData(specialId) {
        let form_data={};
    
        if (typeof specialId == 'undefined') specialId = false;
    
    
        this.elems.inputs.forEach(function(item) {
            let _res = item.val();
    
            if (item.attr("type") == 'checkbox')
            {
                if (item.is(":checked") || item.prop('checked')) _res=1;
                else _res=0;
            }
    
            if (specialId) form_data[item.attr('_id')] = _res;
            else form_data[item.attr('name')]=_res;
        });
    
        this.elems.selects.forEach(function(item) {
            var _res,
                remainingData = ['id', 'newTag', 'text'];
    
            if (item.attr('detailed') == 1 || item.attr('detailed') == true) {
                _res = item.select2('data');
                console.log(_res);
                jQuery.each(_res, function(key, data) {
                    jQuery.each(data, function(dataKey, _notneeded) {
                        if (jQuery.inArray(dataKey, remainingData) == -1) delete _res[key][dataKey];
                    });
                });
            } else _res = item.val();
    
            if (specialId) form_data[item.attr('_id')] = _res;
            else form_data[item.attr('name')]=_res;
        });
    
        this.elems.textareas.forEach(function(item) {
            if (specialId) form_data[item.attr('_id')] = item.val();
            else form_data[item.attr('name')]=item.val();
        });
    
        this.elems.quillEditors.forEach(function(item) {
            var quill = item.data('quill'),
                _res;
    
            if (quill.isEmpty()) _res = '';
            else _res = item.data('quill').quill.container.firstChild.innerHTML;
    
            if (specialId) form_data[item.attr('_id')] = _res;
            else form_data[item.attr('name')] = _res;	
        });
    
        this.elems.inputsHidden.forEach(function(item) {
            var _res = item.val(),
                line = item.parents('.form-line');
    
            if (item.attr("type") == 'checkbox')
            {
                if (item.is(":checked") || item.prop('checked')) _res=1;
                else _res=0;
            } else if (line.find('.phone-input-container').length > 0) {
                _res = line.find('.phone-input-container').data('intltelinput').getNumber(intlTelInputUtils.numberFormat.E164);
            }
    
            if (specialId) form_data[item.attr('_id')] = _res;
            else form_data[item.attr('name')]=_res;
        });

        this.elems.algoliaPlaces.forEach(function(item) {
            let plugin = item.data('th-plugin'),
                _res = plugin.getData();

            if (_res === null) {
                 _res = {
                    query: item.val()
                }
            } else {
                _res = jQuery.extend({}, _res);
                delete _res.rawAnswer;
                delete _res.suggestion.hits;
                delete _res.suggestion.rawAnswer;
            }

            if (specialId) form_data[item.attr('_id')] = _res;
            else form_data[item.attr('name')] = _res;
        });
    
        return form_data;
    }

    /** Fill this form with custom data feeded through an object
     * 
     * @param object data (the data to use to feed this form)
     * 
     */
    fillFormData(data) {
        this.elems.inputs.forEach(function(item) {
            if (typeof data[item.attr('name')] == 'undefined') return;
            item.val(data[item.attr('name')]);
        });

        this.elems.selects.forEach(function(item) {
            item.val(data[item.attr('name')]);
            if (item.hasClass('ams')) item.trigger('change');
        });

        this.elems.textareas.forEach(function(item) {
            item.val(data[item.attr('name')]);
        });

        /** TODO: Missing QUILL Editor */

        this.elems.inputsHidden.forEach(function(item) {
            item.val(data[item.attr('name')]);
        });
    }

    
    /** Validate the form for errors
     * 
     */
    validateForm() {
        let valid=true, 
            submitButton = this.dom.main.find(".form-submit-button");

        this.dom.main.find('.validate-container').each(function() {
            if (!jQuery(this).hasClass('disable-validate') && !jQuery(this).parents('.form-section').hasClass('disable-validate'))
            {
                if (Validator.validate_elem(jQuery(this).find(".validate")) === false) valid=false;
            }
        });

        if (valid)
        {
            if (typeof submitButton.data('after-validate') !== 'undefined' && typeof window[submitButton.data('after-validate')] === 'function')
            {
                window[submitButton.data('after-validate')]();
                return false;
            } else return true;
        } else return false;
    }

    static initializeMultiple() {
        PluginBase.initializeMultiple(this, 'form.tradeholding-javascript-form');
    }
}

export default TH_Form;





